import { object, string } from "yup";
import { nonEmptyString } from "@covertree/utils";

import { LiabilityClaimReason } from "@api/operations.generated";
import {
  InjuredPeopleFormPart,
  injuredPeopleValidation,
} from "../shared/InjuredPersonsSection/form";

interface LiabilityFormPart {
  claimReason: LiabilityClaimReason;
  claimDescription: string;
}
export type LiabilityForm = LiabilityFormPart & InjuredPeopleFormPart;

export const validation = object({
  claimReason: string().required("Claim reason is required"),
  claimDescription: nonEmptyString("Claim description").max(
    3000,
    "Claim description is too long"
  ),
  ...injuredPeopleValidation,
});
